<template>
  <div style="height: 100%; background: #f5f5f5">
    <v-app-bar elevation="0" class="mb-3" color="white">
      <div class="d-flex flex-row align-center">
        <v-img alt="Cellsmart Logo" class="shrink mr-2" contain @click="$router.go(0)" src="../../../assets/fullLogo.png"
          transition="scale-transition" width="160" />
      </div>
      <v-spacer></v-spacer>
      {{ version }}
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click.stop.prevent="switchLocation()">
            <v-list-item-title>Switch Location</v-list-item-title>
          </v-list-item>
          <v-list-item @click.stop.prevent="addTimeClockToken()">
            <v-list-item-title>Time Clock</v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item @click.stop.prevent="$router.push({ path: '/backoffice/login' })">
            <v-list-item-title>Account</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-container grid-list-md>
      <v-layout column justify-center align-center>
        <h1 class="text-center">Login</h1>
        <h4 class="text-center" v-if="location">{{ location.name }}</h4>

        <CSPLoader v-if="loading" />
        <v-flex shrink class="px-3">
          <v-select hide-details label="Select Employee" :items="getTimeClockUsers.admins" v-model="selectedEmployee"
            item-text="name" return-object outlined dense rounded :error-messages="selectedEmployeeErrors"
            @input="$v.selectedEmployee.$touch()" :loading="employees.length === 0"></v-select>
        </v-flex>

        <v-flex shrink v-if="pinView">
          <v-layout column>
            <v-flex>
              <v-text-field outlined dense class="mt-3" rounded v-model="password"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" :type="showPassword ? 'text' : 'password'"
                name="input-10-1" label="Password" counter @click:append="showPassword = !showPassword"></v-text-field>
            </v-flex>
            <v-flex>
              <v-btn block color="success" @click="submit">Login</v-btn>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-container v-else grid-list-lg style="height: 80%" class="mt-2 py-0">
          <v-layout column justify-center align-center class="my-1">
            <v-flex shrink>
              <v-row>
                <v-col v-for="circle in pinCodeCircles" :key="circle">
                  <v-icon x-large :color="pinColor(circle)">{{ pinCodeStyle(circle) }}</v-icon>
                </v-col>
              </v-row>
            </v-flex>


            <v-row align="center" justify="center" class="mt-2">
              <v-col md="4" sm="12">
                <v-layout row justify-center align-center class="px-2">
                  <v-flex shrink xs4 v-for="num in numbers" :key="num">
                    <v-btn fab height="100" :disabled="!selectedEmployee" 
                      @pointerdown.stop.prevent="pointerMode && selectedNum(num)"
                      @click.stop.prevent="!pointerMode && selectedNum(num)" width="100" color="primary">
                      <span class="text-h3">{{ num }}</span>
                    </v-btn>
                    
                  </v-flex>
                  <v-flex xs8>
                    <v-btn height="100" block rounded :disabled="!selectedEmployee"
                      @pointerdown.stop.prevent="pointerMode && selectedNum(0)"
                      @click.stop.prevent="!pointerMode && selectedNum(0)" color="primary">
                      <span class="text-h3">0</span>
                    </v-btn>
                  </v-flex>
                  <v-flex xs4>
                    <v-btn height="100" block rounded  @pointerdown.stop.prevent="pointerMode && clearPin()"
                      @click.stop.prevent="!pointerMode && clearPin()" color="red" :dark="selectedEmployee ? true : false" :disabled="!selectedEmployee">
                      <span class="text-h3">C</span>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-col>
            </v-row>

          </v-layout>
        </v-container>
      </v-layout>
    </v-container>

    <v-bottom-navigation app>
      <v-btn value="recent" block @click="pinView = !pinView">
        Switch to password
      </v-btn>
    </v-bottom-navigation>
  </div>
</template>

<script>
import employeeService from "@/modules/Employee/service.js";
// import locationService from "@/modules/Location/service.js"
// import LoginPad from "@/components/LoginPad.vue";
import authService from "@/modules/Authentication/service.js";
import { mapActions, mapGetters } from "vuex";
const { validationMixin } = require("vuelidate");
const { required } = require("vuelidate/lib/validators");
const pjson = require("../../../../package.json");

export default {
  data() {
    return {
      password: null,
      showPassword: false,
      pinView: false,
      pointerMode: "PointerEvent" in window,
      pin: "",
      selectedEmployee: null,
      numbers: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      pinCodeCircles: [1, 2, 3, 4],
      loading: false,
      taostText: "",
      pinCode: null,
      selectedEmployee: null,
      employees: [],
      location: null,
      locationCode: null,
      deviceCode: null,
      deviceName: null,
    };
  },
  watch: {
    pin() {
      // Reseting Pin
      if (this.pin.length === 5) {
        this.pin = "";
      }

      // Submiting
      if (this.pin.length === 4) {
        this.pinSubmit(this.pin);
      }
    },
    // selectedEmployee() {
    //   if (this.selectedEmployee && this.selectedEmployee.id) {
    //     this.$emit("employeeSubmit", this.selectedEmployee);
    //   }
    // },
  },
  async created() {
    localStorage.removeItem(`${process.env.VUE_APP_STORAGE_PREFIX}backofficeToken`);
    localStorage.setItem(
      `${process.env.VUE_APP_STORAGE_PREFIX}selectedScreen`,
      "Admin Panel"
    );
    if (
      localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}code`) != null
    ) {
      this.locationCode = localStorage.getItem(
        `${process.env.VUE_APP_STORAGE_PREFIX}code`
      );
    } else if (this.$route.params && this.$route.params.locationInstance) {
      const locationInstance = this.$route.params.locationInstance;
      this.locationCode = locationInstance.code;
      this.deviceName = locationInstance.deviceName;
    } else {
      this.$router.push({ name: "authentication-find-location" });
    }

    this.location = JSON.parse(
      localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}location`)
    );

    if (this.locationCode) {
      await authService
        .getLocation(this.locationCode)
        .then(async (response) => {
          this.location = response.data;
          this.locationCode = response.data.code;
          // console.log("emplyee list", response);
          this.employees = response.data.Employees;
          if (this.employees) {
            this.setEmployeeList(this.employees);
          }
          await this.filterAdmins;
        })
        .catch((error) => {
          this.$router.push({ name: "authentication-find-location" });
          console.log(error);
        });
      // console.log(
      //   "lad emplyee",
      //   localStorage.getItem(
      //     `${process.env.VUE_APP_STORAGE_PREFIX}lastEmployeeId`
      //   )
      // );
      if (
        this.getTimeClockUsers.admins &&
        this.getTimeClockUsers.admins.length === 1
      ) {
        this.selectedEmployee = this.getTimeClockUsers.admins[0];
      } else {
        let lastloginId = localStorage.getItem(
          `${process.env.VUE_APP_STORAGE_PREFIX}lastEmployeeId`
        );
        if (lastloginId) {
          this.getTimeClockUsers.admins.map((user) => {
            if (user.id === parseInt(lastloginId)) {
              this.selectedEmployee = user;
            }
          });
        }
      }
    } else {
      this.$router.push({ name: "authentication-find-location" });
    }

    const { deviceName, deviceCode } = authService.getStoredDevice();
    this.deviceName = deviceName;
    this.deviceCode = deviceCode;
    if (
      !localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}deviceCode`)
    ) {
      localStorage.setItem(
        `${process.env.VUE_APP_STORAGE_PREFIX}deviceCode`,
        this.deviceCode
      );
    }
    // if (!this.deviceName) {
    //   this.deviceName = "Phone";
    // }

    console.log("deviceName", this.locationCode, this.deviceCode, deviceName);
  },
  computed: {
    ...mapGetters("global", ["getTimeClockUsers"]),
    version() {
      // console.log('pjson', pjson.version)
      return pjson.version;
    },
    selectedEmployeeErrors() {
      const errors = [];
      if (!this.$v.selectedEmployee.$dirty) return errors;
      if (!this.$v.selectedEmployee.required)
        errors.push("Employee is required.");
      return errors;
    },
    generateTimeClockToken() {
      let rand = function () {
        return Math.random().toString(36).substr(2);
      };

      return rand() + rand();
    },
    filterAdmins() {
      const admins = [];
      const employees = [];
      this.employees.map((user) => {
        if (user.metadata && user.metadata.timeClockLogin) {
          // sorting out admins
          if (user.metadata.timeClockLogin.admin) {
            admins.push(user);
          }

          // soring out employees
          if (user.metadata.timeClockLogin.employee) {
            employees.push(user);
          }
        }
      });

      this.employees.map((user, index) => {
        // if no one specified as admin then user with 0 index will be admin
        if (admins.length === 0) {
          if (index === 0) {
            if (user.metadata && !user.metadata.timeClockLogin) {
              user.metadata.timeClockLogin = {
                admin: true,
                employee: false,
                updateMetaData: true,
              };
              admins.push(user);
            }

            if (
              user.metadata &&
              user.metadata.timeClockLogin &&
              !user.metadata.timeClockLogin.admin &&
              !user.metadata.timeClockLogin.employee
            ) {
              user.metadata.timeClockLogin.admin = true;
              (user.metadata.timeClockLogin.updateMetaData = true),
                admins.push(user);
            }

            if (user && !user.metadata) {
              user.metadata = {
                timeClockLogin: {
                  admin: true,
                  employee: false,
                  updateMetaData: true,
                },
              };
              admins.push(user);
            }
          }
        }
      });

      // adding in store
      this.setTimeClockAdmins(admins);
      this.setTimeClockEmployees(employees);
    },
  },
  mixins: [validationMixin],
  validations: {
    selectedEmployee: {
      required,
    },
  },
  methods: {
    ...mapActions("employee", ["setEmployee"]),
    ...mapActions("global", [
      "setEmployeeList",
      "setTimeClockAdmins",
      "setTimeClockEmployees",
    ]),
    pinColor(num) {
      if (this.pin.length >= num) {
        return "secondary";
      }
      else {
        return "grey";
      }
    },
    pinCodeStyle(num) {
      if (this.pin.length >= num) {
        return "mdi-check-circle";
      }
      else {
        return "mdi-checkbox-blank-circle-outline";
      }
    },
    selectedNum(num) {
      num = num.toString();
      this.pin = this.pin.concat(num).trim();
    },
    clearPin() {
      this.pin = ""
    },
    switchLocation() {
      return this.$swal
        .fire({
          title: "Are you sure?",
          text: "You want to change location account",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.$router.push({ name: "authentication-find-location" });
            // this.$router.push({ path: "/login/location" });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addTimeClockToken() {
      localStorage.setItem(
        `${process.env.VUE_APP_STORAGE_PREFIX}selectedScreen`,
        "Time Clock"
      );
      //await localStorage.setItem(`${process.env.VUE_APP_STORAGE_PREFIX}TimeClocktoken`, this.generateTimeClockToken);
      this.$router.push({ name: "clockInOut" });
    },
    async updateEmployee(id, empdata) {
      const admins = this.getTimeClockUsers.admins;
      // adding it to update state.
      let change = false;

      admins.map(async (user) => {
        if (
          user.metadata &&
          user.metadata.timeClockLogin &&
          user.metadata.timeClockLogin.updateMetaData
        ) {
          delete user.metadata.timeClockLogin.updateMetaData;

          // making it true to update to state.
          change = true;

          await employeeService
            .update(user.id, user)
            .then((response) => response)
            .catch((error) => {
              console.log(error);
              throw error;
            });

          return false;
        }
      });

      if (change) {
        this.setTimeClockAdmins(admins);
        change = false;
      }

      if (id && empdata) {
        return employeeService
          .update(id, empdata)
          .then((response) => response)
          .catch((error) => {
            console.log(error);
            throw error;
          });
      }
    },
    pinSubmit(val) {
      this.pinCode = val;
      this.submit();
    },
    // employeeSubmit(emp) {
    //   console.log('this.selectedEmployeethis.selectedEmployeethis.selectedEmployeethis.selectedEmployeethis.selectedEmployeethis.selectedEmployee')
    //   if (emp) {
    //     this.selectedEmployee = emp;
    //     this.setEmployee(emp);
    //   }
    // },
    setRecentLocation() {

      let recentLocation = JSON.parse(
        localStorage.getItem(
          `${process.env.VUE_APP_STORAGE_PREFIX}recentLocation`
        )
      );
      // console.log("fdffffffffffffff", recentLocation);
      if (recentLocation) {
        recentLocation.map((row) => {
          if (row.code === this.locationCode) {
            if (this.pin) {
              row.pin = this.pin;
              row.employeeId = this.selectedEmployee.id;
            }
            if (this.password) {
              row.pin = this.password;
              row.employeeId = this.selectedEmployee.id;
            }
          }
        });
        localStorage.setItem(
          `${process.env.VUE_APP_STORAGE_PREFIX}recentLocation`,
          JSON.stringify(recentLocation)
        );
      }
    },
    submit() {
      this.$Progress.start();
      this.loading = true;
      const loginInfo = {
        id: this.selectedEmployee.id,
        pin: this.pinView ? this.password : this.pinCode,
        locationCode: this.locationCode,
        deviceCode: this.deviceCode,
        deviceName: this.deviceName,
      };
      authService
        .authenticate(loginInfo)
        .then(async (res) => {
          console.log("res", res);
          this.loading = false;
          // await localStorage.setItem(
          //   `${process.env.VUE_APP_STORAGE_PREFIX}Hometoken`,
          //   this.generateTimeClockToken
          // );
          authService.setLastEmployeeId(this.selectedEmployee.id);

          this.setEmployee(this.selectedEmployee);
          this.setRecentLocation();
          // await this.updateEmployee();
          console.log("going home");
          this.$router.push({ name: "home" });
          console.log("going home done");
        })
        .catch((error) => {
          console.log("error in login", error);
          this.loading = false;
          this.$Progress.fail();
          this.$toast.error(error.data ? error.data.message : "Error", {
            timeout: 2000,
          });

          this.pin = "";
          // this.taostText = "Invalid login";
          // this.snackbar = true;
        });
    },
  },
};
</script>


